/* eslint-disable no-const-assign */
<template>
  <v-container fluid>
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">EXPORTACIONES SFTP</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="getData"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 500],
      }"
      :disable-sort="true"
    >
      <template v-slot:[`item.fechainicio`]="{ item }">
        {{ item.fechainicio ? getDate(item.fechainicio) : "" }}
      </template>
      <template v-slot:[`item.fechafinalizacion`]="{ item }">
        {{ item.fechafinalizacion ? getDate(item.fechafinalizacion) : "" }}
      </template>
      <!-- <template v-slot:[`item.duracion`]="{ item }">
        {{
          item.fechainicio
            ? getDuracion(item.fechainicio, item.fechafinalizacion)
            : ""
        }}
      </template> -->
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip
          small
          :color="item.estado === 'Finalizado' ? 'success' : 'secondary'"
          dark
          v-text="item.estado"
        >
        </v-chip>
      </template>
      <template v-slot:footer>
        <v-btn
          color="success"
          :loading="loading"
          :disabled="loading"
          title="Exportar a Excel"
          @click="exportarExcel"
          class="ml-2"
        >
          <v-icon left>mdi-file-excel</v-icon>
          Exportar a Excel
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
import Paginado from "../../helpers/Paginado";
import Filtros from "../General/Filtros.vue";
import moment from "moment";
import { exportCollectionToExcel } from "./ExportacionesExcel";

export default {
  components: {
    Filtros,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Exportaciones",
  data() {
    return {
      coleccion: "exportaciones",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "fechainicio",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        {
          text: "CASO",
          filterable: true,
          align: "start",
          sortable: true,
          value: "caso",
        },
        { text: "FECHA INICIO", value: "fechainicio" },
        { text: "FECHA FINALIZACIÓN", value: "fechafinalizacion" },
        // { text: "DURACIÓN", value: "duracion" },
        { text: "ESTADO", value: "estado" },
      ],
      condicion: {},
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value === "caso") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    async getData() {
      try {
        const { itemsPerPage, page, sortBy, sortDesc } = this.options;
        this.itemsPerPage = itemsPerPage;
        this.ordenar = sortBy[0] || this.headers[0].value;
        this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
        this.criterios = await this.$refs.criterios.enviarCriterios();
        this.condicion = {};
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.criterios.forEach((element) => {
            if (element.campo && element.valor) {
              this.condicion = {
                campo: element.campo,
                operador: element.operador,
                valor:
                  element.campo != "caso"
                    ? element.valor.toUpperCase().trim()
                    : parseInt(element.valor, 10),
              };
            }
          });
        }
        const paginado = new Paginado(
          db,
          this.coleccion,
          this.ordenar,
          itemsPerPage,
          page,
          this.condicion
        );
        const { registros, total } = await paginado.data();
        this.desserts = registros;
        this.totalItems = total;
        this.loading = false;
      } catch (error) {
        console.log("error", error);
        this.handleError(error);
      }
    },
    getDate: function (date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getDuracion: function (ini, fin) {
      console.log(ini, fin);
      if (ini && fin) {
        const a = moment(ini);
        const b = moment(fin);
        return a.diff(b, "hour");
      }
      return "";
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async exportarExcel() {
      try {
        this.loading = true;

        // Exportar colección 'casos' con la lógica de GeneradordeExcel.js
        const coleccionAExportar = "casos";

        // Generar nombre de archivo con timestamp
        const timestamp = moment().format("YYYYMMDD_HHmmss");
        const fileName = `total_casos_por_uid_${timestamp}.xlsx`;

        console.log(
          `🔄 Iniciando exportación de colección: ${coleccionAExportar}`
        );
        console.log(
          `📋 Usando lógica de GeneradordeExcel.js (agrupado por UID)`
        );

        // Exportar toda la colección DIRECTAMENTE desde Firebase
        // Agrupa por UID (uidinvestigador/uidabogado) y calcula estadísticas
        const result = await exportCollectionToExcel(
          coleccionAExportar, // Colección a exportar ('casos')
          fileName,
          null, // createdStartMs - null para exportar TODOS sin filtro de fecha
          null, // createdEndMs - null para exportar TODOS sin filtro de fecha
          (count) => {
            console.log(`📊 Procesados ${count} documentos...`);
          }
        );

        // El archivo ya se descargó automáticamente usando file-saver
        // Mostrar mensaje de confirmación con detalles
        this.$swal({
          icon: "success",
          title: "Exportación completada",
          text: `Se procesaron ${result.count} documentos.\nSe generaron ${result.rowsCount} filas agrupadas por UID.\nEl archivo "${result.fileName}" se ha descargado.`,
          timer: 5000,
          showConfirmButton: true,
        });
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message ||
            "Error al exportar a Excel. Por favor, intente nuevamente.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style src="./Exportaciones.scss" lang="scss"></style>
